import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { StoryTypeIcon } from '@/components/StoryTypeIcon.tsx'
import { DEFAULT_STORY } from '@/constants/DEFAULT_VALUES.ts'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import { useMutateStoryType } from '@/requests/mutations/useMutateStoryType.ts'

type EditableVersionProps = {
  storyId: string
  value?: string
  status: StoryStatus
}

export const EditableStoryType = ({ storyId, value = DEFAULT_STORY().storyType, status }: EditableVersionProps) => {
  const mutate = useMutateStoryType(storyId)

  return (
    <div>
      <Select value={value} onValueChange={mutate} disabled={status === STORY_STATUSES.ACCEPTED}>
        <SelectTrigger className="w-20 h-8 border-none shadow-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 px-1 py-[5px]">
          <div className="flex items-center justify-between mx-1">
            <SelectValue className="font-EN-KR-caption-regular text-contents-primary" placeholder="Story type" />
          </div>
        </SelectTrigger>
        <SelectContent className="min-w-20 w-20 py-1 px-0 flex flex-col border-none rounded-xs">
          {Object.entries(STORY_TYPES).map(([_key, _value]) => (
            <SelectItem
              key={_key}
              value={_value.toString()}
              className="w-20 px-2 py-1.5 cursor-pointer relative hover:after:bg-stateLayer-onLight-hovered hover:after:opacity-8 after:absolute after:inset-0 rounded-none"
            >
              <div className="flex justify-start items-center gap-1">
                <StoryTypeIcon storyType={_value} />
                <span className="font-EN-KR-caption-regular text-contents-primary">{_value}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export const TypedEditableStoryType = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<string, undefined, ComponentProps<typeof EditableStoryType>> & RefAttributes<EditableCommands>
>
